import script from "./Confirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./Confirm.vue?vue&type=script&lang=ts&setup=true"

import "./Confirm.vue?vue&type=style&index=0&id=b0c25846&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0c25846"]])

export default __exports__